<template>
  <inventoryProductsCategoriesForm :typeEndPoint="'inventoryProductsCategoriesShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProductsCategoriesForm from '@/components/modules/inventory/products/categories/form'
export default {
  name: 'inventoryProductsCategories',
  components: {
    inventoryProductsCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/categories/edit.vue